import axios from "axios";
import { getToken, setToken, clearAuth } from "../utils/storage";

export const API_URL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

interface TokenResponse {
  access: string;
}

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors and refresh the token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const response = await axios.post(
          `${API_URL}/account/token/refresh/`,
          null,
          {
            withCredentials: true, // Include cookies
          }
        );

        const { access } = response.data;
        setToken(access);
        axiosInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${access}`;
        originalRequest.headers["Authorization"] = `Bearer ${access}`;

        // Retry the original request
        return axiosInstance(originalRequest);
      } catch (err) {
        clearAuth();
        const currentPath = window.location.pathname;
        if (!currentPath.includes("/kiosk")) {
          window.location.href = "/login";
        }
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
